<div>
  @if (cartProducts.length > 0) {
    <ul class="carrinho__lista">
      @for (item of cartProducts; track item) {
        <li class="carrinho__item">
          <div class="carrinho__item__info">
            <span class="carrinho__item__quantidade__valor">{{ item.quantity }}x</span>
            <div>
              <div class="carrinho__item__nome">
                <p class="p text-secondary">#{{ item.ticket_id }}</p>
                <p class="p title">{{ item.title }}</p>
              </div>
              <div class="carrinho__item__preco">
                <p class="p m-0">{{ item.price | currency: "BRL" }}</p>
                @if (!item.absorbs_platform_fee && item.tax > 0) {
                  <p class="p text-secondary m-0">(+ {{ item.tax | currency: "BRL" }} taxa)</p>
                }
                @if (item.consumption && item.consumption > 0) {
                  <p class="p text-secondary m-0">Consumação: {{ item.consumption | currency: "BRL" }}</p>
                }
              </div>
            </div>
            <app-button
              styleType="danger"
              class="carrinho__item__remover ps-0 pe-0 p-0"
              (btnClick)="removeProduct(item)">
              Remover
            </app-button>
          </div>
        </li>
      }
    </ul>
  } @else {
    <p class="carrinho__vazio">Seu carrinho está vazio.</p>
  }
</div>
